import { Grid, Paper, Stack, Typography } from "@podcastsoundboard/ps-lib/ui"
export default function TrustedList() {
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4} alignItems="stretch">
          <Paper elevation={4} className="p-8 h-full">
            <Stack
              direction="column"
              spacing={2}
              height="100%"
              alignItems={"center"}
              justifyContent={"center"}
            >
              {/* <LanguageIcon color="inherit" /> */}

              <Typography variant="body1" fontSize="4rem">
                🌏
              </Typography>

              <Stack
                flexGrow={1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h6" fontSize="1.4rem">
                  Thousands of people use Podcast Soundboard in their creative
                  projects.
                </Typography>
              </Stack>
            </Stack>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper elevation={4} className="p-8 h-full">
            <Stack
              direction="column"
              spacing={2}
              height="100%"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <img
                alt=""
                role="presentation"
                style={{
                  height: "4rem",
                  marginTop: "16px",
                }}
                src="/logo192.png"
              />

              <Stack
                flexGrow={1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h6" fontSize="1.4rem">
                  Continually enhanced since 2017 thanks to engaged user
                  feedback.
                </Typography>
              </Stack>
            </Stack>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper elevation={4} className="p-8 h-full">
            <Stack
              direction="column"
              spacing={2}
              height="100%"
              alignItems={"center"}
              justifyContent={"center"}
            >
              {/* <WorkspacePremiumIcon color="inherit" /> */}

              <Typography variant="body1" fontSize="4rem">
                😌
              </Typography>

              <Stack
                flexGrow={1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h6" fontSize="1.4rem">
                  We offer a no-risk 30-day refund policy on any purchase.
                </Typography>
              </Stack>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}
